import { Length, Number, Token, Tuple } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { takeBetween, either, map, filter, delimited, option } = Parser;
/**
 * @internal
 */
export const parse = map(takeBetween(delimited(option(Token.parseWhitespace), filter(either(Length.parse, Number.parse), (size) => size.hasCalculation() || size.value >= 0, () => `Negative sizes are not allowed`)), 1, 4), ([top, right = top, bottom = top, left = right]) => Tuple.of(top, right, bottom, left));
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-image-outset}
 * @internal
 */
export default Longhand.of(Tuple.of(Number.of(0), Number.of(0), Number.of(0), Number.of(0)), parse, (value, style) => value.resolve(Resolver.length(style)));
//# sourceMappingURL=border-image-outset.js.map